import { useParams} from "react-router-dom";
import styles from "./PPTInsertCompletedPage.module.css";
import YuJaButton from "../../components/standardization/YuJaButton";
import {ReactComponent as Success} from "../../images/activity_saved_successfuly_image.svg";
import {ReactComponent as STEP_1_ICON} from "./images/presenting_slide_icon.svg";
import {ReactComponent as STEP_2_ICON} from "./images/scan_qr_icon.svg";
import {ReactComponent as STEP_3_ICON} from "./images/clicking_release_icon.svg";
import {usePPTWebView} from "../../hooks/usePPTWebView";
import {
    POLL_TYPE,
    PPT_RUNNING_APP_TYPE,
} from "../../utils/constants";
import { useTranslation } from "react-i18next";
import parse from 'html-react-parser';
import {deCapitalizeWord} from "../../utils/helpers";
import {ReactComponent as INFO_ICON } from "../../images/info_icon.svg"
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import {PublicApiCall} from "../../apis/PublicApiCall";
import {useState} from "react";

export default function PPTInsertCompletedPage() {
    const { t } = useTranslation();
    const { pollType, from } = useParams();

    const [, getRunningApp] = useLocalStorageNew("PPT_RUNNING_APP", "");
    const [, getInsertedSlides] = useLocalStorageNew("PPT_INSERTED_SLIDES", 2);
    let runningApp = getRunningApp();

    const {getAppId, goPollsPage} = usePPTWebView();

    const {postPPTMessage} = PublicApiCall();

    const [isProcessing, setIsProcessing] = useState(false);


    const goPresentation = () => {
        setIsProcessing(true);
        const messageObj = {};
        let insertedSlidesCount = getInsertedSlides();
        messageObj.action = "activate";
        messageObj.slidesCount = insertedSlidesCount;
        postPPTMessage(getAppId(), JSON.stringify(messageObj)).finally(() => {
            setIsProcessing(false);
        });
    }

    return (
        <div className={styles.container}>
            <div style={{flex: 1}}/>
            <Success/>
            <div style={{height: 25}}/>
            <span className={styles.title}>
                {pollType === POLL_TYPE.ATTENDANCE
                    ? t("poll.pptCompletePageInsertAttendanceSuccessfully")
                    : t("poll.pptCompletePageInsertPollSuccessfully")
                }
            </span>

            <div style={{height: 40}}/>


            <div className={styles.row} style={{flexDirection: 'column'}}>
                {!!from && from === "MacOS" &&
                    <div className={styles.banner} style={{marginBottom: 20}}>
                        <INFO_ICON/>
                        <span>
                            <span style={{fontWeight: "600", marginRight: 3}}>{t("common.attentionPrefix")}</span>
                            {t("integration.pptKeepAppOpen")}
                        </span>
                    </div>
                }
                <div className={styles.stepBox}>
                    <span style={{fontSize: 16}}>
                        {t("poll.pptPresentationGuideAfterInsertingPrefix", {
                            activityType: pollType === POLL_TYPE.ATTENDANCE
                                ? deCapitalizeWord(t("poll.attendanceLabel"))
                                : deCapitalizeWord(t("poll.mergedModeText"))
                        })}
                    </span>

                    <span className={styles.row}>
                        <STEP_1_ICON style={{marginRight: 10, flexShrink: 0}}/>

                        <span>
                            {parse(t("poll.pptPresentationGuideAfterInsertingStep1", {
                                activityType: pollType === POLL_TYPE.ATTENDANCE
                                    ? t("poll.attendanceLabel")
                                    : t("poll.mergedModeText")
                            }))}
                        </span>
                    </span>

                    <span className={styles.row}>
                        <STEP_2_ICON style={{marginRight: 10, flexShrink: 0}}/>
                        <span>
                            {t("poll.pptPresentationGuideAfterInsertingStep2", {
                                activityType: pollType === POLL_TYPE.ATTENDANCE
                                    ? deCapitalizeWord(t("poll.attendanceLabel"))
                                    : deCapitalizeWord(t("poll.mergedModeText"))
                            })}
                        </span>
                    </span>

                    <span className={styles.row}>
                        <STEP_3_ICON style={{marginRight: 10, flexShrink: 0}}/>

                        <span>
                            {parse(t("poll.pptPresentationGuideAfterInsertingStep3"))}
                        </span>
                    </span>
                </div>


                <div style={{height: 30}}/>
                <div style={{display: "flex"}}>
                    <YuJaButton
                        type={"secondary"}
                        onClick={() => goPollsPage()}
                        style={{
                            width: 180,
                            height: 35,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        {t("poll.pptCompletePageGoBackButtonText")}
                    </YuJaButton>
                    {runningApp === PPT_RUNNING_APP_TYPE.GOOGLE_SLIDES &&
                        <>
                            <div style={{width: 30}}/>
                            <YuJaButton
                                onClick={goPresentation}
                                disabled={isProcessing}
                                style={{
                                    width: pollType === POLL_TYPE.ATTENDANCE ? 200 : 180,
                                    height: 35,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    whiteSpace: "nowrap"
                                }}
                            >{pollType === POLL_TYPE.ATTENDANCE
                                ? t("integration.pptViewInsertedAttendance")
                                : t("integration.pptViewInsertedPoll")
                            }</YuJaButton>
                        </>
                    }
                </div>
            </div>
            <div style={{flex: 2}}/>
        </div>
    );
}